import { FormTextEditor } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';
import { InputLabel } from '@mui/material';

type RiskManagementFormProps = {
  planIndex: number;
  riskIndex: number;
  isCompletedTh?: boolean;
  isCompletedEn?: boolean;
};

const RiskManagementForm = ({
  planIndex,
  riskIndex,
  isCompletedTh = false,
  isCompletedEn = false,
}: RiskManagementFormProps) => {
  return (
    <>
      <InputLabel sx={{ mt: 4, fontWeight: 800 }}>
        มาตรการจัดการความเสี่ยง
      </InputLabel>
      <FormTextEditor
        name={`companyValueIncreasePlans.valueUpPlans.${planIndex}.riskManagement.risks.${riskIndex}.measurementTh`}
        label="กรุณาอธิบายมาตรการจัดการความเสี่ยง (ไทย) (ถ้ามี)"
        mt={2}
        inputProps={{
          placeholder: 'กรุณาระบุ (ไทย)',
        }}
        sx={
          isCompletedTh
            ? {
                ...disabledFormInputStyles,
              }
            : undefined
        }
      />
      <FormTextEditor
        name={`companyValueIncreasePlans.valueUpPlans.${planIndex}.riskManagement.risks.${riskIndex}.measurementEn`}
        label="กรุณาอธิบายมาตรการจัดการความเสี่ยง (อังกฤษ) (ถ้ามี)"
        mt={2}
        inputProps={{
          placeholder: 'กรุณาระบุ (อังกฤษ)',
        }}
        sx={
          isCompletedEn
            ? {
                ...disabledFormInputStyles,
              }
            : undefined
        }
      />
    </>
  );
};

export default RiskManagementForm;
